import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";

import { Container } from "reactstrap";
import Header from "./Header";
import Footer from "./Footer";

import Middlepart from "./Middlepart";
import Sidebar from "./Sidebar";
import Alert from 'react-bootstrap/Alert';
import Toast from 'react-bootstrap/Toast';
import { useState, useEffect, useContext } from "react";
import { AlertContext, NotificationContext, HospitalContext, RoleContext } from "../utils/contexts/RoleContext";
import { useNavigate } from "react-router-dom";
import Logo from "./Logo";

import {
    Navbar,
    Collapse,
    Nav,
    NavItem,
    NavbarBrand,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Button,
} from "reactstrap";

// import MiddlePart from "./Middlepart";


const Layout = ({ children }) => {

    const [searchOn, setSearchOn] = useState(false);


    const navigate = useNavigate();
    const currentUser = useContext(RoleContext);
    const toast = useContext(AlertContext);

    const { show, successValue, message } = toast;

    const showMobilemenu = () => {
        document.getElementById("sidebarArea")?.classList.toggle("showSidebar");
    };
    return (
        <main>
            <div className="pageWrapper d-lg-flex">
                {/********Sidebar**********/}
                {/* <aside className="sidebarArea iboost-box-shadow" id="sidebarArea">
          
        </aside> */}
                {/********Content Area**********/}
                <div className="contentArea">
                    {/********header**********/}
                    {/* <Header /> */}
                    <Navbar color="iboost-white" dark expand="md" className="header-nav">
                        <div className="d-flex align-items-center">
                            <h2 className="ms-3 m-auto">CORSIA</h2>
                            {/* <Button

                                className="d-lg-none nav_green"
                                onClick={() => showMobilemenu()}
                            >
                                <i className="bi bi-list"></i>
                            </Button> */}
                        </div>
                        <div className="d-flex align-items-center headersearch_wrap">
                            <div className="mobile-logo ms-auto me-2">
                                <Logo />
                            </div>
                        </div>
                    </Navbar>

                    {/********Middle Content**********/}
                    <Container className={`p-4 wrapper ${searchOn && "mt-3"}`} fluid>

                        {children}
                    </Container>

                </div>

            </div>
            <Footer />
        </main>
    );
};

export default Layout;